export const CHART_UP_COLOR = '#34C759';
export const CHART_DOWN_COLOR = '#FF3B30';

export function getQuoteChangeColor(changePercent) {
    return Number(changePercent) >= 0 ? CHART_UP_COLOR : CHART_DOWN_COLOR;
}

export function getChartTrendColor(prices, fallbackChangePercent = 0) {
    const closes = Array.isArray(prices)
        ? prices
            .map(point => point?.close)
            .filter(value => typeof value === 'number' && Number.isFinite(value))
        : [];

    if (closes.length < 2) return getQuoteChangeColor(fallbackChangePercent);
    return closes[closes.length - 1] >= closes[0] ? CHART_UP_COLOR : CHART_DOWN_COLOR;
}
